import React, { useEffect, useState } from "react";
import { Divider } from "@material-ui/core";
import Applied from "../../../../assets/icons/applied.svg";
import Successful from "../../../../assets/icons/successful.svg";
import Interested from "../../../../assets/icons/interested.svg";
import placeholder from "../../../../assets/icons/placeholder.svg";
import SearchInput from "../../../../components/CustomSearchInput";
import icons from "../../../../assets/icons/icon-collection.svg";

import { useDispatch, useSelector } from "react-redux";
import {
  getReferralStats,
  getReferrers,
} from "../../../../redux/actions/insightActions";
import EmptyState from "../../../../components/EmptyState";

const Referrals = () => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const { referrers, referralStats } = useSelector(({ insight }) => insight);

  const applicationStyleMapper = {
    0: "sent",
    1: "considered",
    2: "test",
    3: "test",
    4: "hired",
    5: "declined",
  };

  const applicationStatusMapper = {
    0: "Application Sent",
    1: "You're being considered",
    2: "Test Stage",
    3: "Interviewing",
    4: "Hired",
    5: "Application Declined",
  };

  const stageChipStyle = {
    background: "#EEF3FF",
    color: "#3A6ED4",
    border: "1px solid #3A6ED4",
    borderRadius: "10px",
    padding: "6px 10px",
    fontSize: "0.75rem",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
  };

  useEffect(() => {
    Promise.all([getReferralStats(dispatch), getReferrers(dispatch, page, 10)]);
  }, [dispatch, page]);
  return (
    <div>
      <div className="d-flex justify-content-between mx-5 mb-3">
        <div className="count co-primary">
          <div className="figure">
            <img src={Interested} alt="Interested" />
            <b>{referralStats?.clicksByReferral || 0}</b>
          </div>
          <p className="my-1 text-center">
            Interested <br /> Candidates
          </p>
        </div>
        <div className="count co-primary">
          <div className="figure">
            <b>{referralStats?.appliedForJob || 0}</b>
            <img src={Applied} alt="Applied" />
          </div>
          <p className="my-1 text-center">
            Your <br /> Applicants
          </p>
        </div>
        <div className="count co-primary">
          <div className="figure">
            <b>{referralStats?.gotEmployed || 0}</b>
            <img src={Successful} alt="Successful" />
          </div>
          <p className="my-1 text-center">
            Successful <br /> Referral
          </p>
        </div>
      </div>
      <Divider />
      <div className="mx-4 my-2">
        <SearchInput
          handleChange={(e) => {
            setSearch(e.target.value);
          }}
        />
        {!referrers?.referreds && <EmptyState text="you have no referrals" />}
        {referrers?.referreds && (
          <>
            {referrers?.referreds
              .filter((referrer) => {
                if (
                  search &&
                  !JSON.stringify(referrer)
                    .toLowerCase()
                    .includes(search.toLowerCase())
                ) {
                  return false;
                }
                return true;
              })
              .map((referrer) => (
                <div key={referrer.id} className="w-100 my-3">
                  <div className="w-100 bg-white border rounded">
                    <div
                      className={`d-flex align-items-center justify-content-between px-4 py-3`}
                    >
                      <div className="d-flex align-items-center">
                        <img
                          width="44"
                          src={
                            referrer.applicant_details.image_url || placeholder
                          }
                          alt="avatar"
                          style={{ borderRadius: "50%" }}
                        />
                        <span className="d-flex flex-column ml-3">
                          <h6 className="mb-0">
                            {referrer.applicant_details.username}
                          </h6>
                          <span className="co-gray small">
                            {referrer.job_details.role_title}
                          </span>
                        </span>
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="mr-3" style={stageChipStyle}>
                          <svg width="10" height="10" className="mr-1">
                            <use href={`${icons}#elipse`}></use>
                          </svg>
                          {applicationStatusMapper[referrer.applicationStage]}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </>
        )}
      </div>
      {referrers?.total_pages > 1 && (
        <div className="d-flex justify-content-end align-items-center mx-4 my-3">
          <button
            className="btn btn-link px-2"
            disabled={page <= 1}
            onClick={() => setPage((p) => Math.max(1, p - 1))}
          >
            Prev
          </button>
          <span className="mx-2 small">
            Page {referrers?.current_page || page} of {referrers?.total_pages}
          </span>
          <button
            className="btn btn-link px-2"
            disabled={page >= (referrers?.total_pages || 1)}
            onClick={() =>
              setPage((p) => Math.min(referrers?.total_pages || 1, p + 1))
            }
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default Referrals;
